import { type Transaction } from '@kalos/kalos-rpc';

/** What a receipt document can be: a photo (including iPhone HEIC) or a PDF. */
export const RECEIPT_DOCUMENT_ACCEPT = 'image/*,.heic,.heif,.pdf';

/** The purchase categories someone without manager or all-cost-center access can pick. */
export const ALLOWED_ACCOUNT_IDS = [
  601002, 673002, 673001, 51400, 643002, 643003, 601001, 51500, 601004, 1, 68500, 66600,
];

/**
 * Whether an activity row is a rejection: 'rejected <reason>' today, 'Transaction rejected.
 * Reason:<reason>' in older rows. Matched by prefix because edit logs ('User X updated txn
 * notes: ...') can mention "rejected" too.
 */
export const isRejectionActivity = (description: string) =>
  description.startsWith('rejected') || description.startsWith('Transaction rejected');

/** Why a rejected receipt came back: the reviewer's words from the last rejection logged. */
export const getRejectionReason = (txn: Transaction) => {
  const res = txn.activityLog.findLast((a) => isRejectionActivity(a.description));
  if (res) {
    return res.description.replace('rejected', '');
  }
  return 'No reason';
};
